export default "__VITE_ASSET__lV1KiTK0__"